// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_3kuJCkfCCDVX0U_CZv4fTW","externalId":"_2kmFhqY7SAb6zLyJjS-Odl"};